import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const CHANGE_IMAGE_GALLERY_ACTIVE_INDEX = 'CHANGE_IMAGE_GALLERY_ACTIVE_INDEX';

// reducer
const DEFAULT_STATE = {};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case CHANGE_IMAGE_GALLERY_ACTIVE_INDEX:
            return {
                ...state,
                [action.payload.itemId]: action.payload.newIndex,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.imageGalleryActiveImage;
const idSelector = (state, id) => id;

export const getImageGalleryActiveImage: (state: any, selector: any) => any = createSelector(
    [stateSelector, idSelector],
    (state, id) => state[id] || 0
);

/* ACTION CREATORS */
export const changeImageGalleryActiveIndex = (itemId: number, newIndex: number) => ({
    payload: { itemId, newIndex },
    type: CHANGE_IMAGE_GALLERY_ACTIVE_INDEX,
});
